import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import StatePage from "./pages/StatePage";
import CoursePage from "./pages/CoursePage";
import TopRated from "./pages/TopRated";
import CoursesDirectory from "./pages/CoursesDirectory";
import StatesIndex from "./pages/StatesIndex";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import BlogIndex from "./pages/BlogIndex";
import BlogPost from "./pages/BlogPost";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import NotFound from "./pages/NotFound";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const PublicLayout = ({ children }) => (
  <>
    <Header />
    <main>{children}</main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
          <Route path="/courses" element={<PublicLayout><CoursesDirectory /></PublicLayout>} />
          <Route path="/all-courses" element={<PublicLayout><CoursesDirectory /></PublicLayout>} />
          <Route path="/states" element={<PublicLayout><StatesIndex /></PublicLayout>} />
          <Route path="/top-rated" element={<PublicLayout><TopRated /></PublicLayout>} />
          <Route path="/state/:stateCode" element={<PublicLayout><StatePage /></PublicLayout>} />
          <Route path="/state/:stateCode/course/:courseId" element={<PublicLayout><CoursePage /></PublicLayout>} />
          <Route path="/state/:stateCode/courses/:courseId" element={<PublicLayout><CoursePage /></PublicLayout>} />
          <Route path="/state/:stateCode/:citySlug" element={<PublicLayout><StatePage /></PublicLayout>} />
          <Route path="/state/:stateCode/:citySlug/*" element={<PublicLayout><StatePage /></PublicLayout>} />
          <Route path="/listing/:listingSlug" element={<PublicLayout><StatePage /></PublicLayout>} />
          <Route path="/listing/:listingSlug/*" element={<PublicLayout><StatePage /></PublicLayout>} />
          <Route path="/city/:citySlug" element={<PublicLayout><StatePage /></PublicLayout>} />
          <Route path="/city/:stateCode/:citySlug" element={<PublicLayout><StatePage /></PublicLayout>} />
          <Route path="/cities/:citySlug" element={<PublicLayout><StatePage /></PublicLayout>} />
          <Route path="/blog" element={<PublicLayout><BlogIndex /></PublicLayout>} />
          <Route path="/blog/:slug" element={<PublicLayout><BlogPost /></PublicLayout>} />
          <Route path="/about" element={<PublicLayout><AboutUs /></PublicLayout>} />
          <Route path="/about-us" element={<PublicLayout><AboutUs /></PublicLayout>} />
          <Route path="/contact" element={<PublicLayout><ContactUs /></PublicLayout>} />
          <Route path="/contact-us" element={<PublicLayout><ContactUs /></PublicLayout>} />
          <Route path="/privacy-policy" element={<PublicLayout><PrivacyPolicy /></PublicLayout>} />
          <Route path="/privacy" element={<PublicLayout><PrivacyPolicy /></PublicLayout>} />
          <Route path="/terms-and-conditions" element={<PublicLayout><TermsConditions /></PublicLayout>} />
          <Route path="/terms" element={<PublicLayout><TermsConditions /></PublicLayout>} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/" element={<AdminLogin />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/dashboard/" element={<AdminDashboard />} />
          <Route path="/admin/*" element={<AdminLogin />} />
          <Route path="*" element={<PublicLayout><NotFound /></PublicLayout>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
